module.exports = __webpack_public_path__ + "img/digitalIdentity2.00c8e76e.png";